import { getId } from "../utils";
export var HeadlineFlag;
(function (HeadlineFlag) {
    /* The article has a chance of generating reduced revenue per view, especially if it gets popular. */
    HeadlineFlag[HeadlineFlag["DEMONETIZATION_LIKELY"] = 0] = "DEMONETIZATION_LIKELY";
    /* The headline is misleading. This will increase CTR but disappoint readers, who will be
       less likely to share the article. */
    HeadlineFlag[HeadlineFlag["MISLEADING_HEADLINE"] = 1] = "MISLEADING_HEADLINE";
    /* The article contains significant/intentional inaccuracies. This will cause some
       readers to ignore the article and others to become more radical. */
    HeadlineFlag[HeadlineFlag["FALSE"] = 2] = "FALSE";
    /* Readers are likely to respond with a "heart" emoji. */
    HeadlineFlag[HeadlineFlag["HEARTWARMING"] = 3] = "HEARTWARMING";
    /* Readers are likely to respond with an "angry" emoji. */
    HeadlineFlag[HeadlineFlag["INFURIATING"] = 4] = "INFURIATING";
    /* Readers are likely to respond with an "awestruck" emoji. */
    HeadlineFlag[HeadlineFlag["INSPIRING"] = 5] = "INSPIRING";
    /* Readers are likely to respond with a "rofl" emoji. */
    HeadlineFlag[HeadlineFlag["HILARIOUS"] = 6] = "HILARIOUS";
    /* Readers are likely to respond with a "sad" emoji. */
    HeadlineFlag[HeadlineFlag["SAD"] = 7] = "SAD";
    /* The headline or article is designed to play to readers' fears, at the expense of accuracy.
       This polarizes the article: people who agree will share it more, people who are opposed will
       share it less, and those in the middle will ignore it. Can also radicalize readers. */
    HeadlineFlag[HeadlineFlag["FEARMONGERING"] = 8] = "FEARMONGERING";
    /* The headline or article is unnecessarily harsh and designed to radicalize readers. */
    HeadlineFlag[HeadlineFlag["INFLAMMATORY"] = 9] = "INFLAMMATORY";
})(HeadlineFlag || (HeadlineFlag = {}));
export default class Headline {
    constructor(title, topics = [], quality = 3, clickbait = 3, flags = [], storyline = null) {
        this.id = getId();
        this.topics = [];
        this.flags = [];
        this.inProgress = false;
        this.title = title;
        this.topics = topics;
        this.flags = flags;
        this.quality = quality;
        this.clickbait = clickbait;
        this.storyline = storyline;
    }
}
